<template>
    <span class="price">
        <div class="price__object">
            <template v-if="price > 0">

                <span v-if="showFrom" class="price__from">From</span>
                <span class="price__value">
                    {{ formatPrice(price) }}
                </span>
            </template>
            <span v-else class="price__sold-out">Sold out</span>
            <abbr v-if="showPPPW && price > 0" class="price__pppw" title="per-person per-week">pp/pw</abbr>
        </div>
        <span v-if="showYear && price > 0" class="price__year">{{ academicYear }}</span>
    </span>
</template>
<script setup>
import { toRef } from 'vue';
import { formatPrice } from '@utils/format.js';
const props = defineProps({
    // The price purely as a number
    price: {
        type: Number,
        default: 0,
        required: true
    },
    // The academic year range that the price was pulled from as a string, e.g.
    // 2023/24
    selectedAcademicYear: {
        type: String,
        required: true
    },
    // Show the "From" label
    showFrom: {
        type: Boolean,
        default: true
    },
    // Show the academic year
    showYear: {
        type: Boolean,
        default: true
    },
    // Show the "pp/pw" label
    showPPPW: {
        type: Boolean,
        default: true
    }
});

const academicYear = toRef(props, 'selectedAcademicYear');
</script>